import React from 'react';
import { ListGroup, ListGroupProps } from 'react-bootstrap';

export type GenericListVariant =
  | 'flush'
  | 'numbered'
  | 'disabled'
  | 'horizontal';

export type customGenericListProps = ListGroupProps &
  React.PropsWithChildren<{
    variant?: GenericListVariant;
  }>;

const GenericList = ({
  variant = 'flush',
  children,
}: customGenericListProps) => {
  return (
    <ListGroup variant={variant} className="custom-list-group">
      {children}
    </ListGroup>
  );
};

export default GenericList;
